module.exports = __webpack_public_path__ + "img/scan (3).cedd8de6.jpg";